package com.gsb.vyapar.bhagya.presentation.navigation.util

import com.gsb.vyapar.bhagya.datasource.cache.SqlDelightClient
import com.gsb.vyapar.bhagya.datasource.network.KtorClient
import com.gsb.vyapar.bhagya.datasource.preference.Preference
import com.gsb.vyapar.bhagya.domain.*
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.interactor.util.*
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.auth.util.*
import com.gsb.vyapar.bhagya.presentation.business.util.hasBusiness
import com.gsb.vyapar.bhagya.presentation.dialog.Dialogs
import com.gsb.vyapar.bhagya.presentation.dialog.uistate.DialogUiState

fun pushView(screen: Screens) {
    val navStack = getState().navViewStack
    navStack.push(screen)
    updateState(getState().copy(navView = navStack.peek(), navViewStack = navStack))
}

fun popView() {
    val navStack = getState().navViewStack
    navStack.pop()
    updateState(getState().copy(navView = navStack.peek(), navViewStack = navStack))
}

fun onAccountClick() {
    try {
        val user = getState().getUser()
        if (!isUserLoggedIn()) {
            loginPopup()
        } else {
            checkUser(user.getId())
        }
    } catch (e: Exception) {
        loginPopup()
    }
}

fun checkUser(userId: String) {
    showLoading()
    launchDefault {
        val result = KtorClient.getUser(userId)
        hideLoading()
        if (result.isSuccess) {
            updateState(getState().copy(user = result.getOrNull()?.toUser()?.encodeUserString() ?: User().encodeUserString()))
            Preference.user = getState().user
            checkUserAfterLogin()
        } else {
            showError("Failed to load retry")
        }
    }
}

fun checkUserAfterLogin() {
    val user = getState().getUser()
    if (user.getEmail().isEmpty()) {
        launchVerifyEmail()
    } else  {
        pushView(Screens.Register)
    }
}

fun showDeleteAccount() {
    if (hasBusiness()) {
        showError("Please ensure that all businesses associated with the account are deleted before proceeding with the account deletion.")
    } else {
        updateState(getState().copy(dialogUiState = DialogUiState(dialogType = Dialogs.Regular, message = "Are you sure you want to delete account?", onCancelClick = {
            updateState(getState().copy(dialogUiState = null))
        }, onOKClick = {
            updateState(getState().copy(dialogUiState = null))
            deleteUser(getState().getUser())
        })))
    }
}

fun showClearData() {
    updateState(getState().copy(dialogUiState = DialogUiState(dialogType = Dialogs.Regular, message = "Are you sure you want to clear all app data? This action cannot be undone.", onCancelClick = {
        updateState(getState().copy(dialogUiState = null))
    }, onOKClick = {
        updateState(getState().copy(dialogUiState = null))
        Preference.clearPreference()
        launchDefault {
            SqlDelightClient.clearDB()
        }
        updateState(uiState = UiState())
    })))
}

fun showSignOutPopup() {
    updateState(getState().copy(dialogUiState = DialogUiState(dialogType = Dialogs.Regular, message = "Are you sure you want to Sign Out?", onCancelClick = {
        updateState(getState().copy(dialogUiState = null))
    }, onOKClick = {
        updateState(getState().copy(dialogUiState = null))
        logout()
    })))
}